import * as React from 'react';
import type { UsuarioAutenticado } from './tipos';

export interface ContextoAuth {
  usuario: UsuarioAutenticado | null;
  carregando: boolean;
  entrar: (email: string, senha: string) => Promise<UsuarioAutenticado>;
  sair: () => Promise<void>;
  /** Atualiza o usuário em memória, ex.: após trocar a senha. */
  atualizarUsuario: (dados: Partial<UsuarioAutenticado>) => void;
}

/**
 * Contexto e hook ficam separados do componente provedor: exportar hooks e
 * constantes ao lado de componentes desativa o fast refresh do Vite.
 */
export const ContextoAuthReact = React.createContext<ContextoAuth | null>(null);

export function useAuth(): ContextoAuth {
  const contexto = React.useContext(ContextoAuthReact);

  if (!contexto) {
    throw new Error('useAuth precisa ser usado dentro de <ProvedorAuth>.');
  }

  return contexto;
}
